import { render, staticRenderFns } from "./OfferMessage.vue?vue&type=template&id=13f19d28&"
import script from "./OfferMessage.vue?vue&type=script&lang=js&"
export * from "./OfferMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports